<template>
  <div>
    <h3 class="modal-title"> CANVAS </h3>

    <b-form-group :class="{'error-input' : $v.data_form.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_form.title.$model"
        :max-length="255"
        placeholder="Form Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_form.canvas.$error}">
      <label> Select Canvas</label>
      <j-single-select
        v-model="$v.data_form.canvas.$model"
        :load-options="loadOptionsCanvas"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Select Canvas'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeForm">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveForm">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_form: {
      title: {
        required,
      },
      canvas: {
        required,
      },
    },
  },
  data() {
    return {
      data_form: {
        title: '',
        canvas: null,
      },
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    generateDataForm() {
      const dataField = {
        canvas_id: this.data_form.canvas.id,
      };

      const data = {
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_form.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },

    generateDataFormUpdate() {
      const dataField = {
        canvas_id: this.data_form.canvas.id,
      };

      const data = {
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_form.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },
  },
  watch: {
  },
  mounted() {
    if (this.modeEdit) {
      const info = JSON.parse(this.dataEdit.info);
      this.data_form.title = this.dataEdit.name;

      const dataFilter = {
        id: info.canvas_id,
      };
      const params = {
        limit: 1,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      this.findCanvas(params).then((response) => {
        if (response) {
          const dataCanvas = response[0];
          dataCanvas.label = dataCanvas.name;
          this.data_form.canvas = dataCanvas;
        }
      });
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm']),
    ...mapActions('jStoreFormUi', ['findCanvas']),

    loadOptionsCanvas({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 100,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreFormUi/actionGetCanvasListAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    saveForm() {
      this.$v.data_form.$touch();
      if (!this.$v.data_form.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataForm,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataFormUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeForm();
      }
    },

    closeForm() {
      this.$emit('close-field');
      this.data_form.title = '';
      this.data_form.canvas = null;
      setTimeout(() => {
        this.$v.data_form.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jCanvasSetup.vue